// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__6Kr30","paramInput":"JobSimulator_paramInput__3Yx94","input":"JobSimulator_input__1LOj4"};